import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        primary: {
            main: "#005ca9",
        },
        secondary: {
            main: "#ff9800",
        },
        background: {
            default: "#f5f5f5",
            paper: "#ffffff",
        },
        text: {
            primary: "#ffffff",
            secondary: "#ffffff",
        },
    },
    typography: {
        fontFamily: "Helvetica Neue",
        h5: {
            fontWeight: 600,
            color: "#ffffff",
        },
        button: {
            textTransform: "none",
            fontWeight: "bold",
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                    padding: "10px 20px",
                    border: "2px solid #fff",
                    fontSize:'2rem',
                    fontWeight:'bold',
                    color: "#ffffff",
                    '&.Mui-disabled': {
                        border: "2px solid rgb(79, 173, 255)",
                        color: "rgb(79, 173, 255)",
                        backgroundColor:'#005ca9',
                    },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        fontSize:'2rem',
                        border:'2px solid #fff',
                        borderRadius: 0,
                        '& fieldset': {
                            borderColor: "white",
                        },
                        '& input': {
                            color: "white",
                        },
                        '&:hover fieldset': {
                            borderColor: "white",
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: "white",
                        },
                    },
                    '& .MuiInputLabel-root': {
                        fontWeight:'bold',
                        fontSize:'2rem',
                        color: "white",
                        '&.Mui-focused': {
                            color: "white",
                        },
                    },
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: "#ffffff",
                    '&.Mui-checked': {
                        color: "#ffffff",
                    },
                    '&:hover': {
                        backgroundColor: "transparent",
                    },
                    '& .MuiSvgIcon-root': {
                        fontSize: 50, // Aumenta la dimensione della checkbox
                        borderRadius: 0, // Rimuove gli angoli arrotondati
                    },
                },

            },
        },
    },
});

export default theme;
